// extracted by mini-css-extract-plugin
module.exports = {"button":"_93444fe79c--button--1q8yR","badge":"_93444fe79c--badge--3P1hh"};